import { render, staticRenderFns } from "./businessDatabusManage.vue?vue&type=template&id=72df8764&scoped=true"
import script from "./businessDatabusManage.vue?vue&type=script&lang=js"
export * from "./businessDatabusManage.vue?vue&type=script&lang=js"
import style0 from "./businessDatabusManage.vue?vue&type=style&index=0&id=72df8764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df8764",
  null
  
)

export default component.exports